import React from "react";
import "./Container.css";
import { IProps } from "./IProps";

const Container: React.FC<IProps> = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default Container;
